import { FC } from "react";import { useAdminConfig, useAppDispatch } from "hooks";
import { updateConfig } from "State/admin_actions";

interface ProductConfigProps {}

const ProductConfig: FC<ProductConfigProps> = () => {
  const dispatch = useAppDispatch();
  const config = useAdminConfig();

  const handleToggle = (field: keyof typeof config) => {
    const currentValue = config[field];
    // Normalize null to 0, then toggle between 0 and 1
    const normalizedValue = currentValue ?? 0;
    const nextValue = typeof normalizedValue === "boolean" 
      ? !normalizedValue 
      : (normalizedValue === 1 ? 0 : 1);
    
    dispatch(
      updateConfig({
        [field]: nextValue,
      }),
    );
  };

  return (
    <div className="font-body tracking-wider space-y-6">
      <div>
        <h3 className="text-sm font-medium">Product Configuration</h3>
        <p className="text-xs text-gray-500 mt-1">
          Customize how products are displayed and managed
        </p>
      </div>

      <div className="space-y-4">
        <div className="bg-white p-4 rounded-md border border-gray-200">
          <div className="space-y-4">
            {config?.industryType === "Books" ? (
              <>
                <ConfigToggle
                  label="Author"
                  description="Show authors"
                  enabled={config.isAuthor}
                  onToggle={() => handleToggle("isAuthor")}
                />

                <ConfigToggle
                  label="Language"
                  description="Display language information"
                  enabled={config.isLanguage}
                  onToggle={() => handleToggle("isLanguage")}
                />

                <ConfigToggle
                  label="Academic"
                  description="Show available academic information"
                  enabled={config.isAcademic}
                  onToggle={() => handleToggle("isAcademic")}
                />

                <ConfigToggle
                  label="Merchandise"
                  description="Display merchandise"
                  enabled={config.isMerchandise}
                  onToggle={() => handleToggle("isMerchandise")}
                />

                <ConfigToggle
                  label="Offers"
                  description="Show offers"
                  enabled={config.isOffers}
                  onToggle={() => handleToggle("isOffers")}
                />

                <ConfigToggle
                  label="Events"
                  description="Show events"
                  enabled={config.isEvents}
                  onToggle={() => handleToggle("isEvents")}
                />

                <ConfigToggle
                  label="Glossary"
                  description="Show glossary"
                  enabled={config.isGlossary}
                  onToggle={() => handleToggle("isGlossary")}
                />

                <ConfigToggle
                  label="History"
                  description="Show history"
                  enabled={config.isHistory}
                  onToggle={() => handleToggle("isHistory")}
                />

                <ConfigToggle
                  label="Promotion"
                  description="Show promotions"
                  enabled={config.isPromotionEnabled}
                  onToggle={() => handleToggle("isPromotionEnabled")}
                />

                <ConfigToggle
                  label="Sell Books"
                  description="Show sell books"
                  enabled={config.isSellBooksEnabled}
                  onToggle={() => handleToggle("isSellBooksEnabled")}
                />

                <ConfigToggle
                  label="Loyalty Points"
                  description="Allow loyalty points"
                  enabled={config.isLoyaltyPointsEnabled ? 1 : 0}
                  onToggle={() => handleToggle("isLoyaltyPointsEnabled")}
                />

                <ConfigToggle
                  label="Wallet"
                  description="Enable wallet for customers"
                  enabled={config.isWalletEnabled ? 1 : 0}
                  onToggle={() => handleToggle("isWalletEnabled")}
                />
              </>
            ) : (
              <>
                <ConfigToggle
                  label="Model"
                  description="Show Model"
                  enabled={config.isModel}
                  onToggle={() => handleToggle("isModel")}
                />
                <ConfigToggle
                  label="Size"
                  description="Show Size"
                  enabled={config.isSize}
                  onToggle={() => handleToggle("isSize")}
                />
                <ConfigToggle
                  label="Sleeve"
                  description="Show Sleeve"
                  enabled={config.isSleeve}
                  onToggle={() => handleToggle("isSleeve")}
                />
                <ConfigToggle
                  label="Color"
                  description="Show Color"
                  enabled={config.isColor}
                  onToggle={() => handleToggle("isColor")}
                />
                <ConfigToggle
                  label="Fabric"
                  description="Show Fabric"
                  enabled={config.isFabric}
                  onToggle={() => handleToggle("isFabric")}
                />
                <ConfigToggle
                  label="Occasion"
                  description="Show Occasion"
                  enabled={config.isOccasion}
                  onToggle={() => handleToggle("isOccasion")}
                />
                <ConfigToggle
                  label="Collar"
                  description="Show Collar"
                  enabled={config.isCollar}
                  onToggle={() => handleToggle("isCollar")}
                />
                <ConfigToggle
                  label="Pattern"
                  description="Show Pattern"
                  enabled={config.isPattern}
                  onToggle={() => handleToggle("isPattern")}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductConfig;

interface ConfigToggleProps {
  label: string;
  description: string;
  enabled: 0 | 1;
  onToggle: () => void;
}

const ConfigToggle: FC<ConfigToggleProps> = ({
  label,
  description,
  enabled,
  onToggle,
}) => {
  return (
    <div className="flex items-start sm:items-center justify-between gap-3">

      <div>
        <label className="text-xs font-medium text-gray-700">{label}</label>
        <p className="text-[11px] sm:text-xs text-gray-500 max-w-[14rem] sm:max-w-none">{description}</p>
      </div>
      <button onClick={onToggle}
      className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full self-center ${
      enabled ? "bg-blue-600" : "bg-gray-200"
    }`}
>

        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${
            enabled ? "translate-x-6" : "translate-x-1"
          }`}
        />
      </button>
    </div>
  );
};
